import { useMemo } from "react";
import { useHasAnyAccrualLedger } from "@api/ledger.api";
import { createBillsViewConfig } from "@components/bills/views/billsView/billsViewConfig";
import { useEntities } from "@hooks/useEntities";

export function useBillsTaskViewConfig() {
    const entities = useEntities({ onlyBusiness: true });
    const entityIds = useMemo(
        () => entities.map((entity) => entity.id),
        [entities],
    );
    const hasAnyAccrualLedgers = useHasAnyAccrualLedger(entityIds);
    const viewConfig = useMemo(
        () => createBillsViewConfig({ hasAnyAccrualLedgers }),
        [hasAnyAccrualLedgers],
    );
    return { hasAnyAccrualLedgers, viewConfig };
}
